export default __webpack_public_path__ + "static/media/CL01.2.52e6749e.mp3";